import { type ColorToken } from '../../types';
import type { SpacingToken, SpacingValue } from './types';

export const SPACING_MAP: Record<SpacingToken, SpacingValue> = {
  '0': undefined,
  '1': 0.5,
  '2': 1,
  '3': 2,
  '3-half': 3,
  '4': 4,
  '5': 5,
  '0--wide': undefined,
  '1--wide': { md: 0.5 },
  '2--wide': { md: 1 },
  '3--wide': { md: 2 },
  '3-half--wide': { md: 3 },
  '4--wide': { md: 4 },
  '5--wide': { md: 5 },
};

export const COLORS_MAP: Record<ColorToken, string> = {
  // safari handles 'transparent' strangely, so we define it using rgba instead
  transparent: 'rgba(255,255,255,0)',

  // Brand Colors
  green: 'green.main',
  'green-light': 'greens.light',
  'green-lighter': 'greens.lighter',
  'green-lighter-2': 'greens.lighter',
  'green-lightest': 'greens.lightest',
  'green-extra-light': 'greens.extraLight',
  'green-dark': 'greens.dark',
  'green-darkest': 'greens.darkest',
  'nw-green': '#8ccb32',
  'nw-logo-green': '#00AE4D',
  'nw-logo-green-dark': 'greens.darkLogo',
  'nw-logo-green-light': '#8DC63F',

  blue: 'blue.main',
  'blue-light': 'blues.light',
  'blue-lighter': 'blues.lighter',
  'blue-lighter-2': 'blues.lighter-2',
  'blue-lightest': 'blues.lightest',
  'blue-extra-light': 'blues.extra-light',
  'blue-dark': 'blues.dark',
  'blue-darkest': 'blues.darkest',

  red: 'red.main',
  'red-light': 'reds.light',
  'red-lighter': 'reds.lighter',
  'red-lighter-2': 'reds.lighter-2',
  'red-lightest': 'reds.lightest',
  'red-extra-light': 'reds.extra-light',
  'red-dark': 'reds.dark',
  'red-darker': 'reds.darker',

  yellow: 'yellows.main',
  'yellow-light': 'yellows.light',
  'yellow-lighter': 'yellows.lighter',
  'yellow-lighter-2': 'yellows.lighter2',
  'yellow-lightest': 'yellows.lightest',
  'yellow-extra-light': 'yellows.extraLight',
  'yellow-dark': 'yellows.dark',
  'yellow-darkest': 'yellows.darkest',

  white: 'common.white',
  'neutral-darkest': 'neutral.darkest',
  'neutral-darker-2': 'neutral.darker-2',
  'neutral-darker': 'neutral.darker',
  'neutral-dark': 'neutral.dark',
  'neutral-extra-dark': 'neutral.extra-dark',
  'neutral-light': 'neutral.light',
  'neutral-lighter': 'neutral.lighter',
  'neutral-lighter-2': 'neutral.lighter-2',
  'neutral-lightest': 'neutral.lightest',

  bone: 'bone.main',

  brown: 'brown.main',
  'brown-light': 'browns.light',
  'brown-lighter': 'browns.lighter',
  'brown-lighter-2': 'browns.lighter-2',
  'brown-lighter-3': 'browns.lightest',
  'brown-lighter-4': 'browns.extra-light',
  'brown-lightest': 'browns.lightest',
  'brown-extra-light': 'browns.extra-light',
  'brown-dark': 'browns.dark',
  'brown-darkest': 'browns.darkest',

  teal: 'blues.main',
  'teal-light': 'blues.lightest',
};
